import { render, staticRenderFns } from "./EcgVisitaEditComponent.vue?vue&type=template&id=6413ba54"
import script from "./EcgVisitaEditComponent.vue?vue&type=script&lang=js"
export * from "./EcgVisitaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports